<mat-dialog-content class="dialog-content">
  <section class="sso-provider-section">
    @if (isLoading) {
      <mds-loader></mds-loader>
    }

    @if (!isLoading) {
      <div class="section-header">
        <h3 class="title">SSO Provider Configurations</h3>
        @if (!isAddingNew) {
          <mds-button
            [icon]="icons.PLUS_DARK"
            [isIconLeft]="true"
            (click)="addNewConfiguration()" type="secondary">
            Add Configuration
          </mds-button>
        }
      </div>

      @if (configurations.length === 0 && !isAddingNew) {
        <div class="empty-state">
          <p>No SSO configurations found. Click "Add Configuration" to create one.</p>
        </div>
      }

      @if (isAddingNew) {
        <div class="new-config-card">
          <h4 class="card-title">New Configuration</h4>

          <div class="form-field">
            <mat-label>Configuration Name *</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['configuration_name']" matInput name="new_configuration_name" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Provider Type *</mat-label>
            <mat-form-field appearance="outline">
              <mat-select [(ngModel)]="newConfigFormData['provider_type']" name="new_provider_type">
                @for (option of providerTypeOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Provider *</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['provider']" matInput name="new_provider" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Authorize Endpoint{{ isRequired('authorize_endpoint', newConfigFormData) ? ' *' : '' }}</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['authorize_endpoint']" matInput name="new_authorize_endpoint" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Exchange Token Endpoint *</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['exchange_token_endpoint']" matInput name="new_exchange_token_endpoint" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>User Info Endpoint{{ isRequired('user_info_endpoint', newConfigFormData) ? ' *' : '' }}</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['user_info_endpoint']" matInput name="new_user_info_endpoint" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Redirect URI{{ isRequired('redirect_uri', newConfigFormData) ? ' *' : '' }}</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['redirect_uri']" matInput name="new_redirect_uri" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Client ID{{ isRequired('client_id', newConfigFormData) ? ' *' : '' }}</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['client_id']" matInput name="new_client_id" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Client Secret{{ isRequired('client_secret', newConfigFormData) ? ' *' : '' }}</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['client_secret']" matInput name="new_client_secret" type="password" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Grant Type *</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['grant_type']" matInput name="new_grant_type" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Response Type{{ isRequired('response_type', newConfigFormData) ? ' *' : '' }}</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['response_type']" matInput name="new_response_type" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Response Mode{{ isRequired('response_mode', newConfigFormData) ? ' *' : '' }}</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['response_mode']" matInput name="new_response_mode" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Scope *</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['scope']" matInput name="new_scope" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Code Challenge Method{{ isRequired('code_challenge_method', newConfigFormData) ? ' *' : '' }}</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['code_challenge_method']" matInput name="new_code_challenge_method" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-label>Logo</mat-label>
            <mat-form-field appearance="outline">
              <input [(ngModel)]="newConfigFormData['logo']" matInput name="new_logo" type="text" />
            </mat-form-field>
          </div>

          <div class="form-field toggle-field">
            <mds-slide-toggle
              [(ngModel)]="newConfigFormData['ui_login_button_enabled']"
              label="Show Login Button on UI"
              name="new_ui_login_button_enabled"
            ></mds-slide-toggle>
          </div>

          <div class="form-field toggle-field">
            <mds-slide-toggle
              [(ngModel)]="newConfigFormData['allow_sso_user_provision']"
              label="Auto-provision Users on First SSO Login"
              name="new_allow_sso_user_provision"
            ></mds-slide-toggle>
          </div>

          <div class="form-field">
            <mat-label>User Attributes Mapping (JSON)</mat-label>
            <mat-form-field appearance="outline">
              <textarea
                (ngModelChange)="onJsonFieldChange(newConfigFormData, 'user_attributes_mapping', $event)"
                [ngModel]="getJsonString(newConfigFormData['user_attributes_mapping'])"
                matInput
                name="new_user_attributes_mapping"
                rows="4"
              ></textarea>
            </mat-form-field>
          </div>

          <div class="card-actions">
            <mds-button (click)="cancelNewConfiguration()" type="secondary">Cancel</mds-button>
            <mds-button (click)="saveNewConfiguration()" type="primary">Save</mds-button>
          </div>
        </div>
      }

      <mat-accordion>
        @for (config of configurations; track config.configuration_name; let i = $index) {
          <mat-expansion-panel
            (closed)="expandedPanels.delete(i)"
            (opened)="expandedPanels.add(i)"
            [expanded]="expandedPanels.has(i)"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ config.configuration_name }}
              </mat-panel-title>
              <mat-panel-description>
                @for (field of config.fields; track field.key) {
                  @if (field.key === 'provider_type' && field.value) {
                    {{ field.value }}
                  }
                }
              </mat-panel-description>
            </mat-expansion-panel-header>

            <form (keydown.enter)="$event.preventDefault()" autocomplete="off" class="config-form">
              @for (field of config.fields; track field.key) {
                @if (isTextField(field)) {
                  <div class="form-field">
                    <mat-label>{{ field.label }}{{ isRequired(field.key, getFormData(i)) ? ' *' : '' }}</mat-label>
                    <mat-form-field appearance="outline">
                      <input
                        [(ngModel)]="getFormData(i)[field.key]"
                        [disabled]="isLockedField(field.key)"
                        [name]="'config_' + i + '_' + field.key"
                        [type]="getFieldType(field.key)"
                        autocomplete="off"
                        matInput
                      />
                    </mat-form-field>
                  </div>
                }

                @if (isSelectField(field)) {
                  <div class="form-field">
                    <mat-label>{{ field.label }}{{ isRequired(field.key, getFormData(i)) ? ' *' : '' }}</mat-label>
                    <mat-form-field appearance="outline">
                      <mat-select [(ngModel)]="getFormData(i)[field.key]" [disabled]="isLockedField(field.key)" [name]="'config_' + i + '_' + field.key">
                        @for (option of providerTypeOptions; track option.value) {
                          <mat-option [value]="option.value">{{ option.label }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }

                @if (isCheckboxField(field)) {
                  <div class="form-field toggle-field">
                    <mds-slide-toggle
                      [(ngModel)]="getFormData(i)[field.key]"
                      [label]="field.label"
                      [name]="'config_' + i + '_' + field.key"
                    ></mds-slide-toggle>
                  </div>
                }

                @if (isJsonField(field)) {
                  <div class="form-field">
                    <mat-label>{{ field.label }}{{ isRequired(field.key, getFormData(i)) ? ' *' : '' }}</mat-label>
                    <mat-form-field appearance="outline">
                      <textarea
                        (ngModelChange)="onJsonFieldChange(getFormData(i), field.key, $event)"
                        [name]="'config_' + i + '_' + field.key"
                        [ngModel]="getJsonString(getFormData(i)[field.key])"
                        matInput
                        rows="4"
                      ></textarea>
                    </mat-form-field>
                  </div>
                }
              }

              <div class="card-actions">
                <mds-button (click)="$event.stopPropagation(); deleteConfiguration(config)" type="warn">Delete</mds-button>
                <mds-button (click)="saveConfiguration(i)" type="primary">Save</mds-button>
              </div>
            </form>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </section>
</mat-dialog-content>
